import { html, property } from 'lit-element';
import { nothing } from 'lit-html';
import { KatLitElement, register } from '../../shared/base';
import baseStyles from '../../shared/base/base.lit.scss';
import styles from './summary.lit.scss';

/**
 * @component {kat-summary} KatSummary The summary component allows builders to summarize information collected and decisions made through a workflow, and provide a place for actions, if relevant.
 * @slot default Content for the summary.
 * @slot actions Optional actions for the summary.
 * @status Production
 * @example Default {"header": "Example Header", "subheader": "Example Subheader", "content": "<div slot=\"actions\"><kat-button>Action</kat-button></div>"}
 * @a11y {keyboard}
 * @a11y {sr}
 * @a11y {contrast}
 */
@register('kat-summary')
export class KatSummary extends KatLitElement {
  static get styles() {
    return [baseStyles, styles];
  }

  /** Header that will be displayed. */
  @property()
  header?: string;

  /** Subheader that will be displayed. */
  @property()
  subheader?: string;

  render() {
    const renderedHeader = this.header
      ? html`<h2 class="header">${this.header}</h2>`
      : nothing;

    const renderedSubheader = this.subheader
      ? html`<div class="subheader">${this.subheader}</div>`
      : nothing;

    return html`${renderedHeader}${renderedSubheader}<slot></slot
      ><slot name="actions"></slot>`;
  }
}
